module.exports = __webpack_public_path__ + "img/lt.d1be94a2.svg";